import React from 'react'
import { AppState } from '@chegg-wt/core/state'
import { connect } from 'react-redux'
import PageStructure from '@chegg-wt/core/components/SourceSearchPageStructure'
import { UpgradePromotionBoxCopy } from '@chegg-wt/core/types/copy'
import {
  AppRouteName,
  SourceType,
  Credibility,
  UpgradeCopy,
} from '@chegg-wt/core/types/core'
import {
  sourceTypeSelected,
  sourceQueryEntered,
} from '@chegg-wt/core/state/createCitation/actions'
import {
  createCitationSourceTypeSelector,
  currentSourceSelector,
} from '@chegg-wt/core/state/createCitation/selectors'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'

export interface SourceSearchProps {
  copy?: {
    upgradeCopy?: UpgradeCopy
    considerCredibility?: Credibility
    seoContent?: string
    upgradePromotionCopy?: UpgradePromotionBoxCopy
  }
  styleId?: string
  initialUrlStyleName?: string
  initialSourceType: string
  currentSourceType: string
  currentStyle: string
  currentSourceTypeResource: SourceType
  selectSourceType: (sourceType: string, redirectTo?: AppRouteName) => void
  setSearchQuery: (query: string) => void
}

const SourceSearch: React.FC<SourceSearchProps> = ({
  currentSourceType,
  currentStyle,
  currentSourceTypeResource,
  selectSourceType,
  setSearchQuery,
  copy,
  styleId,
  initialUrlStyleName,
  initialSourceType,
}) => (
  <PageStructure
    copy={copy}
    styleId={styleId}
    initialUrlStyleName={initialUrlStyleName}
    initialSourceType={initialSourceType}
    currentStyle={currentStyle}
    currentSourceType={currentSourceType}
    setSearchQuery={setSearchQuery}
    selectSourceType={selectSourceType}
    currentSourceTypeResource={currentSourceTypeResource}
  />
)

export const mapStateToProps = (state: AppState) => ({
  currentSourceType: createCitationSourceTypeSelector(state),
  currentStyle: currentStyleSelector(state),
  currentSourceTypeResource: currentSourceSelector(state),
})

export const mapDispatchToProps = {
  selectSourceType: sourceTypeSelected,
  setSearchQuery: sourceQueryEntered,
}

export default connect(mapStateToProps, mapDispatchToProps)(SourceSearch)

export { SourceSearchPageStructureTop } from '@chegg-wt/core/components/SourceSearchPageStructure'
